export default __webpack_public_path__ + "static/media/3.ee32e6a9.jpg";